// 巡检记录图片查看组件
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useEffect } from 'react'
import { Spin, theme, Image, Button } from 'antd'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'


/**
 * 
 * @param {Array} picData ['Url1','Url2','Url3']
 * @param {Array} arrData 所有数据（选填，为头部样式框）
 * @param {Number} imgIdx 当前点击图片所对应的idx下标
 * @param {Blob} open 是否打开
 * @param {callback}  pageChange  上一条下一条回调
 * @param {callback}  closeChange  关闭回调
 * @param {callback}  imgBackChange  图片回退
 * @param {Blob}  isLiftPage  是否还有上一张图片
 * @param {Blob}  isRightPage  是否还有下一张图片
 * @param {Blob}  loading  加载框
 * @returns React.JSX.Element 
 */

function ShowImgs({ arrData = [], picData = [], imgIdx = 0, loading, open, isRightPage, isLiftPage, pageChange, closeChange, imgBackChange, }) {
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数
  const {
    token: { colorBgContainer, colorText },
  } = theme.useToken(); //获取主题颜色

  const onkeydown = (e) => {   // 监听键盘事件来展示图片上下页
    if (e.code === 'ArrowLeft') {//上一页
      // console.log('组件监听，上一页');
      pageChange(imgIdx - 1)
    }
    if (e.code === 'ArrowRight') {//下一页
      // console.log('组件监听，下一页');
      pageChange(imgIdx + 1)
    }
  }

  useEffect(() => {
    window.addEventListener("keydown", onkeydown);
    return () => {
      window.removeEventListener('keydown', onkeydown); // 销毁
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imgIdx])

  return (
    <div>
      <Image.PreviewGroup
        preview={{
          src: picData[imgIdx],
          visible: open,//是否显示
          current: imgIdx,
          onVisibleChange: (vis) => { closeChange(vis) },
          onChange: (e) => { pageChange(e) },
          imageRender: (originalNode) => {
            const divDom = (
              <div className='flex jcc align_center' style={{ height: '100vh', }}>
                {/* <div> */}
                {originalNode}
                {/* </div> */}
                <>{/* 头部标题 */}
                  {
                    arrData.length > 0 &&
                    <div className='pos_abs h46' style={{ color: colorText, top: 0, width: '100vw', backgroundColor: 'rgba(14,14,14,0.2)' }}>
                      <div className='flex pdL24 fs20 opa80 lh46'>
                        <div className='pointer' >
                          {/* 日期 */}
                          <span className=''>{arrData[imgIdx]?.addtime}</span>
                        </div>
                      </div>
                    </div>
                  }
                </>

                <>{/* 翻条数 */}
                  {/* 上一条 */}
                  <div
                    onClick={() => { pageChange(imgIdx - 1) }}
                    className={
                      `${(isLiftPage) ? 'ant-image-preview-switch-left' : 'ant-image-preview-switch-left ant-image-preview-switch-left-disabled'}`
                    }
                  >
                    <LeftOutlined />
                  </div>

                  {/* 下一条 */}
                  <div
                    onClick={() => { pageChange(imgIdx + 1) }}
                    className={
                      `${isRightPage ? 'ant-image-preview-switch-right' : 'ant-image-preview-switch-right ant-image-preview-switch-right-disabled'}`
                    }
                  >
                    <RightOutlined />
                  </div>
                </>


                <>{/* 页码 */}
                  <div
                    className='pos_abs fs18'
                    style={{ color: colorText, bottom: 90 }}
                  >
                    {`${imgIdx + 1}  /  ${picData.length}`}
                  </div>
                </>


              </div>
            )
            return divDom
          },
        }}
      >
      </Image.PreviewGroup>
    </div>
  )
}
export default ShowImgs;